<script setup>
import VModal from '@/components/ui/modal/VModal'
import VInput from '@/components/ui/form/VInput'
import VPhone from '@/components/ui/form/VMask'
import { defineEmits, defineProps } from 'vue'
import VFile from '@/components/ui/form/File/VFile'
import { useError } from '@/use/Form/useError'

const emit = defineEmits(['close', 'send'])

defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
})

const { formData, validateField, v$, onSubmit, isSend } = useError(emit)

const handlerClose = () => {
  onSubmit()
}
</script>

<template>
  <VModal
    v-if="isOpen"
    modal-inner-class="width-885 flex-direction"
    scroll-y
    @close="$emit('close')">
    <h2 class="modal__title mb-40">Сообщить об ошибке</h2>
    <p class="mb-30">
      Уважаемые Партнёры, в связи недавней разработкой тендерной площадки, на ней могут возникать
      ошибки, мешающие польноценному использованию функционала. Если вы столкнулись с ошибками,
      сообщите нам о ней, заполнив краткую форму. Разработчик ЭТП, при необходимости, свяжется с
      Вами, для уточнения деталей и устранит ошибку. Спасибо Вам за помощь в улучшении тендерной
      площадки.
    </p>
    <VInput
      id="name"
      v-model="formData.name"
      name="name"
      validator-name="onlyText"
      :errors="v$.name.$errors"
      :class-input="['input input-long input-placeholder-black input-border-bottom']"
      placeholder="Как к вам обращаться*"
      @blur="validateField"
      @input="validateField" />

    <VPhone
      id="phone"
      v-model="formData.phone"
      type="phone"
      name="phone"
      mask-type
      placeholder="Номер телефона"
      :class-input="['input input-long input-placeholder-black']" />

    <VInput
      id="email"
      v-model="formData.email"
      name="email"
      type="text"
      :class-input="['input input-long input-placeholder-black input-border-bottom']"
      placeholder="E-mail" />

    <VInput
      id="description"
      v-model="formData.description"
      name="description"
      :errors="v$.description.$errors"
      :max-length="1500"
      :class-input="['input input-long input-placeholder-black input-border-bottom']"
      placeholder="Описание ошибки*"
      @blur="validateField"
      @input="validateField" />

    <VFile
      id="files"
      v-model="formData.files"
      label="Прикрепить файл"
      class="max-w-initial mb-30"
      name="files"
      icon-name-btn-delete="DeleteFile"
      multi-file
      grid />

    <button class="btn btn-primary btn-bg-green" :disabled="isSend" @click="handlerClose">
      Отправить
    </button>
    <div class="text-center mt-30">
      Пользуясь сайтом или отправляя любые формы запросов,
      <br />
      Вы соглашаетесь с условиями
      <a
        class="btn btn-link"
        href="https://tender-demo.ru/politika-obrabotki-personalnyh-dannyh"
        target="_blank"
        >«Положения о конфиденциальности»</a
      >
    </div>
  </VModal>
</template>
